"use client";
import { FC } from "react";

import { stegaClean } from "next-sanity";

import dynamic from "next/dynamic";

const Vimeo = dynamic(() => import("@u-wave/react-vimeo"), { ssr: false });

interface CaseVimeoVideoProps {
  id: string;
}

const CaseVimeoVideo: FC<CaseVimeoVideoProps> = ({ id }) => {
  return (
    <Vimeo
      responsive
      showByline={false}
      showPortrait={false}
      video={stegaClean(id)}
    />
  );
};
export default CaseVimeoVideo;
